 import React, { useState } from "react";
import { Link } from "react-router-dom";  
const Search = () => {
   const [searchTerm, setSearchTerm] = useState("");

  const pages = [
    { name: "Home", path: "/" , internal: true}, 
    { name: "About Us", path: "/AboutUs" , internal: true}, 
    { name: "Vission & Mission", path: "/VissionMission" , internal: true}, 
    { name: "Examination & Promotion", path: "/ExaminationPromotion" , internal: true}, 
    { name: "Fee", path: "/Fee" , internal: true}, 
    { name: "Withdrawals & Dismissals", path: "/WithdrawalsDismissals" , internal: true}, 
    { name: "Uniform", path: "/SchoolUniform" , internal: true}, 
    { name: "Admission", path: "/Admission" , internal: true}, 
    { name: "Admission Requirements", path: "/AdmissionRequirements" , internal: true}, 
    { name: "Registration", path: "/Registration" , internal: true}, 
    { name: "Gallery", path: "/Gallery" , internal: true}, 
    { name: "Video Gallery", path: "/VideoGallery" , internal: true}, 
    { name: "Contact Us", path: "/ContactUs" , internal: true},  
    { name: "Transfer Certificate", path: "/Tc" , internal: true}, 
    { name: "Erp Software", path: "/ErpSoftware" , internal: true}, 
  ];

  const filteredPages = pages.filter(page =>
    page.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
 
  return (
    <> 
     <form onSubmit={(e) => e.preventDefault()}>
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
        <i className="bi bi-search"></i>
      </form>  

                {searchTerm && (
        <ul className="searchlist">
 {filteredPages.map((page, index) => (
            <li key={index}>
              {page.internal ? (
                <Link to={page.path}>{page.name}</Link>
              ) : (
                <a href={page.path} target="_blank" rel="noopener noreferrer">
                  {page.name}
                </a>
              )}
            </li>
          ))}
          {filteredPages.length === 0 && <li>No pages found</li>}
        </ul>
      )}  
      </>
  );
};

export default Search;
